import React, { FC, useState } from "react";
import "./LsmExtended.css";
import NavbarComponent from "../Navbar/Navbar";
import ScrollToTop from "../services/scrollToTop";
import Lsm2025 from "../Lsm2025/Lsm2025";
import Lsm2023 from "../Lsm2023/Lsm2023";

interface LsmExtendedProps {}

const tabs = [
  { key: "2025", label: "2025" },
  { key: "2023", label: "2023" },
];

const LsmExtended: FC<LsmExtendedProps> = () => {
  const [activeTab, setActiveTab] = useState("2025");

  return (
    <div className="LsmExtended">
      <ScrollToTop />
      <NavbarComponent />

      {/* Tab bar */}
      <div className="lsm-tab-bar-wrapper">
        <div className="lsm-tab-bar">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              className={`lsm-tab${activeTab === tab.key ? " lsm-tab--active" : ""}`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Active year */}
      {activeTab === "2025" && <Lsm2025 embedded />}
      {activeTab === "2023" && <Lsm2023 embedded />}
    </div>
  );
};

export default LsmExtended;
